import { render } from "./AccessDenied.vue?vue&type=template&id=47f872b1"
const script = {}
script.render = render

export default script